import { useMutation } from "@tanstack/react-query";
import { loginUser, LoginUserParams } from "../api/auth-request";
import { toast } from "sonner";
import { HttpStatusCode, isAxiosError } from "axios";
import { useCurrentUser } from "./use-current-user";

const login = async (user: LoginUserParams) => {
  const response = await loginUser(user);
  return response.data;
};

export const useLoginUser = () => {
  const { loadUser } = useCurrentUser();

  return useMutation({
    mutationFn: login,
    onSuccess: () => {
      toast.success("Login Successfully!");
      loadUser();
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        switch (error.status) {
          case HttpStatusCode.BadRequest:
            toast.error("All fields were required");
            break;
          case HttpStatusCode.NotAcceptable:
            toast.error(error.response?.data.message);
            break;
          default:
            toast.error("Something went wrong");
        }
      }
    },
  });
};
